import styled from '@emotion/styled'
import { Container, Row, Col } from 'react-bootstrap'
import { PrimaryButton } from '@mmsg/louie'
import { ITheme } from 'utils/type'

interface IHomeElementsProps {
  theme: ITheme
}

export const HomeContainer = styled('div')<IHomeElementsProps>`
  label: homeContainer;
  margin-left: auto;
  margin-right: auto;
  text-align: left;

  & svg {
    height: 91px;
  }

  & > div {
    margin: 0 auto;
  }
  & > div:nth-of-type(2) {
    margin: -122px auto 0;
    @media (max-width: 719px) {
      margin: -52px auto 0;
    }
  }
  & h2 {
    font-weight: 800;
    font-size: 19px;
    line-height: 26px;
    color: ${(props) => props.theme.colors.secondaryHeading};
    margin-bottom: 20px;
  }

  & p {
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 32px;
  }
  & > .section-testimonials {
    max-width: 996px;
    padding-top: 0;
    .carousel {
      .carousel-control-prev,
      .carousel-control-next {
        z-index: 10;
      }
      .carousel-control-prev-icon,
      .carousel-control-next-icon {
        position: absolute;
        width: 25px;
        height: 22px;
      }
      .carousel-control-prev-icon {
        background-image: url('../images/prev-icon.png');
        left: 0;
      }
      .carousel-control-next-icon {
        background-image: url('../images/next-icon.png');
        right: 0;
      }
      .carousel-item {
        p {
          color: #999;
          font-size: 12px;
          line-height: 44px;
          text-align: left;
          margin-bottom: 0;
        }
        h3 {
          font-size: 28px;
          line-height: 36px;
          color: ${(props) => props.theme.colors.primary};
          text-align: left;
          font-weight: 800;
        }
        .image,
        svg {
          max-width: 270px !important;
          width: 100%;
        }
        .carousel-caption {
          position: relative;
          left: 0;
          right: 0;
          padding-left: 30px;
          padding-right: 30px;
        }
        .testimonial-image-wrapper {
          // TODO(VJ): breakdown Testimonial component
          @include media-breakpoint-up(lg) {
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            position: absolute;
            content: '';
            opacity: 1;
            background: url('../images/bg-testimonials-2.png') no-repeat center;
            background-size: 189px 167px;
          }
          .user-image-wrapper {
            display: flex;
            align-items: center;
            height: 100%;

            .user-image {
              width: 130px;
              height: 130px;
              border-radius: 100px;
              margin: 0 auto;
              background: linear-gradient(
                to bottom,
                ${(props) => props.theme.colors.primary} 0%,
                ${(props) => props.theme.colors.primary} 100%
              );
              padding: 5px;
            }
          }
        }
      }

      .carousel-indicators {
        bottom: -45px;
      }

      .carousel-indicators li {
        background-color: #999;
        z-index: 10;
        height: 12px;
        width: 40px;
        border-radius: 4px/18px;
      }

      .carousel-indicators li.active {
        background-color: ${(props) => props.theme.colors.primary};
        z-index: 10;
      }
    }
  }
  .accordion-benefits {
    margin-top: 100px;
    @media (max-width: 719px) {
      margin-top: 20px;
    }
    hr {
      margin: 0;
    }
    .toggle {
      background: #f7f7f7;
      position: relative;
      display: inline-block;
      top: -14px;
      font-weight: bold;
      font-size: 18px;
      color: ${(props) => props.theme.colors.primary};
      .btn-toggle {
        font-size: 0;
        border: solid ${(props) => props.theme.colors.primary};
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 4px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        min-width: 5px;
        position: absolute;
        right: 10px;
        top: 7px;
        svg,
        img {
          display: none;
        }
      }
    }

    .toggle > div:first-child {
      display: inline-block;
      padding-right: 30px;
      padding-left: 10px;
      text-decoration: underline;
      font-weight: 800;
    }
  }
  .ui-list-container {
    margin-bottom: 100px;
    @media (max-width: 719px) {
      margin-bottom: 0px;
    }
  }
`

export const ContainerBlock = styled(Container)`
  label: ContainerBlock;
  text-align: left;
  color: black;
  line-height: 32px;
`

export const BrandHeading = styled('h2')<IHomeElementsProps>`
  label: BrandHeading;
  color: ${(props) =>
    props.theme.colors
      .secondaryHeading} !important; //TODO(VJ): remove this imp later
  text-transform: uppercase;
  font-weight: 700;
`

export const WhiteHeading = styled('h2')`
  label: WhiteHeading;
  color: ${props=>props.theme.colors.white} !important;
  margin-bottom: 0;
`
export const BrandedH1 = styled('h1')<IHomeElementsProps>`
  label: BrandedH1;
  color: ${(props) => props.theme.colors.textDarkblack} !important;
  font-weight: 800;
  line-height: 48px;
  margin-bottom: 27px;
  text-align: left;
  font-size: 32px;
`

export const DefaultH1 = styled('h1')`
  label: DefaultH1;
  color: #333;
  text-align: left;
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 27px;
`
export const CustomDefaultH1 = styled(DefaultH1)`
  label: CustomDefaultH1;
  font-weight: 700;
  font-size: 32px !important;
`

export const BannerButtonLinkParent = styled(Row)`
  label: BannerButtonLinkParent;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 719px) {
    flex-direction: column;
  }
`
export const BannerButtonLinkChild = styled('div')`
  label: BannerButtonLinkChild;
  @media (max-width: 719px) {
    padding: 25px 0 0px 0;
    a > button {
      min-width: 324px;
    }
  }
`

export const BannerButtonTitleRow = styled(Row)`
  label: BannerButtonTitleRow;
  font-weight: bold;
`
export const BannerPrimaryButton = styled(PrimaryButton)`
  label: BannerPrimaryButton;
  min-width: 324px;
  @media (max-width: 719px) {
    font-size: 14px !important;
    font-weight: 600 !important;
    padding: 9px 18px !important;
    min-width: 214px;
  }
`
export const BannerPrimaryInverted = styled(BannerPrimaryButton)`
  label: BannerPrimaryInverted;
  background: #fff0;
  margin-top: 24px;
  @media (max-width: 719px) {
    margin-top: 0px;
  }
`

export const CircleImageIcon = styled.img`
  label: CircleImageIcon;
  width: 100%;
  @media (max-width: 719px) {
    width: 50%;
  }
`
